// Remount the sidebar if it unloaded itself.
function ensureSideBar() {
  if (!document.querySelector('[data-react-class="Glassfrog.components.SideBar"]').hasChildNodes())
    ReactRailsUJS.mountComponents('.app-side-bar')
}

export default {ensureSideBar}
